export interface Category {
  id: number;
  name: string;
  slug: string;
  url: string;
  icon: string;
  description: string;
}

export const categories: Category[] = [
  {
    id: 1,
    name: 'Shoes',
    slug: 'shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    icon: 'ri-footprint-line',
    description: 'Latest sneakers and footwear finds',
  },
  {
    id: 2,
    name: 'Hoodies/Sweaters',
    slug: 'hoodies-sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    icon: 'ri-t-shirt-line',
    description: 'Cozy hoodies and stylish sweaters',
  },
  {
    id: 3,
    name: 'T-Shirts',
    slug: 't-shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    icon: 'ri-shirt-line',
    description: 'Essential tees for every wardrobe',
  },
  {
    id: 4,
    name: 'Jackets',
    slug: 'jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    icon: 'ri-honour-line',
    description: 'Outerwear and statement jackets',
  },
  {
    id: 5,
    name: 'Pants/Shorts',
    slug: 'pants-shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    icon: 'ri-git-branch-line',
    description: 'Bottoms from casual to streetwear',
  },
  {
    id: 6,
    name: 'Headwear',
    slug: 'headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    icon: 'ri-mental-health-line',
    description: 'Caps, beanies, and head accessories',
  },
  {
    id: 7,
    name: 'Sets',
    slug: 'sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    icon: 'ri-stack-line',
    description: 'Coordinated outfit sets and bundles',
  },
  {
    id: 8,
    name: 'Underwear/Underpants',
    slug: 'underwear-underpants',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    icon: 'ri-user-line',
    description: 'Essential undergarments and basics',
  },
  {
    id: 9,
    name: 'Jersey',
    slug: 'jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    icon: 'ri-medal-line',
    description: 'Sports jerseys and athletic wear',
  },
  {
    id: 10,
    name: 'Accessories',
    slug: 'accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    icon: 'ri-glasses-line',
    description: 'Watches, glasses, and style extras',
  },
  {
    id: 11,
    name: 'Bags',
    slug: 'bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    icon: 'ri-briefcase-line',
    description: 'Backpacks, totes, and messenger bags',
  },
  {
    id: 12,
    name: 'Belts',
    slug: 'belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    icon: 'ri-link',
    description: 'Designer belts and statement pieces',
  },
  {
    id: 13,
    name: 'Perfumes',
    slug: 'perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    icon: 'ri-drop-line',
    description: 'Premium fragrances and scents',
  },
  {
    id: 14,
    name: 'Other Stuff',
    slug: 'other-stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    icon: 'ri-more-line',
    description: 'Everything else worth discovering',
  },
];